<template>
  <div>
    <v-btn
      class="mb-mt-6"
      color="primary"
      @click="dialog = true"
      absolute
      right
    >
      Add document
    </v-btn>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title> Add new document </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-file-input
                v-model="document"
                label="Document file"
              ></v-file-input
            ></v-row>
            <v-row
              ><v-col cols="12" md="6">
                <v-text-field
                  v-model="docName"
                  label="Document Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="docCategorie"
                  :items="categories"
                  label="Categorie"
                  item-value="id"
                  item-text="name"
                  solo
                ></v-select></v-col
            ></v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addDocument"
            :disabled="!canSendDoc"
          >
            Save
          </v-btn>
        </v-card-actions>
        <v-overlay absolute :value="loading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import USER_API from "../../api/user";
import axios from "../../plugins/axios";

export default {
  props: {
    categories: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loadingDoc: false,
      dialog: false,
      document: null,
      docCategorie: null,
      docName: null,
      loading: false,
      commentLoading: false,
      valid: true
    };
  },
  computed: {
    ...mapGetters(["getActiveEntity"]),
    canSendDoc() {
      return this.docCategorie && this.docName && this.document && this.valid;
    }
  },
  methods: {
    async addDocument() {
      this.loading = true;
      USER_API.addNewDocument(this.document, this.docName, this.docCategorie)
        .then(({ data }) => {
          USER_API.getDocument(data.id).then(response => {
            const document = response.data;
            const category = this.categories.find(
              el => el.id === document.documentcategories_id
            );
            document.documentcategories_id = category
              ? category.completename
              : document.documentcategories_id;
            this.$emit("newdocadded", document);
          });
        })
        .catch(({ response }) => {
          axios.defaults.headers["Content-Type"] = "application/json";
          this.setError(response.data[1]);
        })
        .finally(() => {
          this.loading = false;
          this.dialog = false;
          this.finalImg = undefined;
          this.document = null;
          this.docName = null;
          this.docCategorie = null;
        });
    }
  },
  watch: {
    document() {
      this.$refs.form.validate();
    }
  }
};
</script>
